import React, { FC } from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch } from "../../../../store/reduxHooks";
import { AdditionalDocument } from "../../../../types/documents.type";
import { applicationBankDocumentsApi } from "../../../../services/documents/documents.api";
import { GetSignInfoQueryParams } from "../../../../store/api/applicationBankApi/signing.api";
import { OPEN_SIGN_INFO_MODAL } from "../../../../store/slices/applicationBankSlice/applicationBankSlice";
import { getClientSign } from "../../../../utils/utilities/documents/getClientSign";
import { UI_ModuleDocuments } from "../../../../UI_ITO/indexUI";
import { TagSign } from "../ApplicationDetailsDoсList/TagSign/TagSign";
import { DownloadOutlined } from "@ant-design/icons";

interface ApplicationDetailsDoсSectionProps {
  documents: AdditionalDocument[];
}

const { downloadDocument, downloadDocumentSignFile } =
  applicationBankDocumentsApi;

const ApplicationDetailsDoсSection: FC<ApplicationDetailsDoсSectionProps> = ({
  documents,
}) => {
  const { applicationBankId } = useParams();

  const dispatch = useAppDispatch();

  const openSignInfoModal = (params: GetSignInfoQueryParams) => {
    dispatch(OPEN_SIGN_INFO_MODAL(params));
  };
  return (
    <div style={{ paddingBottom: "24px" }}>
      {documents[0]?.document?.map((docKkb) => {
        const clientSignFile = getClientSign(docKkb || null);
        return (
          <div key={docKkb.name + docKkb.id}>
            <UI_ModuleDocuments
              title={docKkb.name}
              titleDown={
                docKkb.name ? (
                  <span
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      if (docKkb && applicationBankId) {
                        downloadDocument({
                          applicationBankId: Number(applicationBankId),
                          fileId: docKkb.id,
                          fileName: docKkb.name,
                        });
                      }
                    }}
                  >
                    {docKkb.name}
                  </span>
                ) : (
                  "Документ не загружен"
                )
              }
              icon={
                <>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-end",
                      gap: "10px",
                    }}
                  >
                    <TagSign
                      tag={clientSignFile ? "sign_true" : "sign_false"}
                      onClickDownload={() => {
                        if (docKkb && applicationBankId && clientSignFile) {
                          downloadDocumentSignFile({
                            applicationBankId: Number(applicationBankId),
                            fileId: docKkb.id,
                            signId: clientSignFile.id,
                            fileName: clientSignFile.name,
                          });
                        }
                      }}
                      onClickSignInfo={() => {
                        if (docKkb && applicationBankId && clientSignFile) {
                          openSignInfoModal({
                            applicationBankId: Number(applicationBankId),
                            fileId: docKkb.id,
                            signId: clientSignFile.id,
                          });
                        }
                      }}
                    />
                  </div>
                  <DownloadOutlined
                    style={{ color: "black" }}
                    onClick={() => {
                      if (docKkb && applicationBankId) {
                        downloadDocument({
                          applicationBankId: Number(applicationBankId),
                          fileId: docKkb.id,
                          fileName: docKkb.name,
                        });
                      }
                    }}
                  />
                </>
              }
            />
          </div>
        );
      })}
    </div>
  );
};

export default ApplicationDetailsDoсSection;
